var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConflictResolutionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ead53e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.69,19.81,13.36,2.71a1.54,1.54,0,0,0-.57-.59,1.53,1.53,0,0,0-1.58,0,1.54,1.54,0,0,0-.57.59L1.31,19.81a1.45,1.45,0,0,0,0,1.53,1.58,1.58,0,0,0,.56.56,1.61,1.61,0,0,0,.77.2H21.33a1.61,1.61,0,0,0,.77-.2,1.58,1.58,0,0,0,.56-.56A1.45,1.45,0,0,0,22.69,19.81Zm-9.14-1.22a.38.38,0,0,1-.11.29.36.36,0,0,1-.27.11H10.83a.36.36,0,0,1-.27-.11.38.38,0,0,1-.11-.29v-2.3a.38.38,0,0,1,.11-.29.36.36,0,0,1,.27-.11h2.34a.36.36,0,0,1,.27.11.38.38,0,0,1,.11.29v2.3Zm0-4.54a.27.27,0,0,1-.13.2.42.42,0,0,1-.28.08H10.87a.55.55,0,0,1-.29-.08.23.23,0,0,1-.12-.2L10.25,8.5a.28.28,0,0,1,.12-.25.51.51,0,0,1,.29-.14h2.68a.48.48,0,0,1,.29.14.26.26,0,0,1,.12.23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConflictResolutionIcon);
export default __webpack_public_path__ + "static/media/conflict_resolution_icon.7b3d51c2c4747772c0e7a021c604effb.svg";
export { ForwardRef as ReactComponent };